export default __webpack_public_path__ + "static/self_mobile-7fda874eb3531a2554d2bfb5a836eb1f.mp4";